import { AfterViewInit, ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { Chart } from 'angular-highcharts';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss'],
})
export class BarChartComponent implements AfterViewInit {
  elements: any;
  barChart!: Chart;
  constructor(
    private router: Router,
    private tableService: DashboardService,
    private cdr: ChangeDetectorRef
  ) {}
  ngOnInit() {
    this.loadData();
    this.renderChart();
  }
  loadData() {
    this.tableService.filterData$.subscribe((data: any) => {
      this.elements = data;
      if (this.elements) {
        localStorage.setItem('filterTableData', JSON.stringify(this.elements));
        this.renderChart();
      }
    });
  }
  renderChart() {
    const storeData = localStorage.getItem('filterTableData');
    const parsedData = storeData ? JSON.parse(storeData) : null;
    if (parsedData) {
      const segments = [
        'LR1',
        'AFRAMAX',
        'HANDY',
        'MR',
        'SUEZMAX',
        'LPG',
        'LR2',
      ];
      const segmentCounts: any = {};
      const negativeCounts: any = {};
      segments.forEach((segment) => {
        segmentCounts[segment] = 0;
        negativeCounts[segment] = 0;
      });
      parsedData.forEach((element: any) => {
        if (element.segment in segmentCounts) {
          segmentCounts[element.segment]++;
          const hsfo =
            element.bunkerLostOrGain.HSFO === '__'
              ? 0
              : parseFloat(element.bunkerLostOrGain.HSFO);
          const vlsfo =
            element.bunkerLostOrGain.VLSFO === '__'
              ? 0
              : parseFloat(element.bunkerLostOrGain.VLSFO);
          const go =
            element.bunkerLostOrGain.GO === '__'
              ? 0
              : parseFloat(element.bunkerLostOrGain.GO);
          if (element.timeLost < 0) {
            negativeCounts[element.segment]++;
          } else if (hsfo + vlsfo + go < 0) {
            negativeCounts[element.segment]++;
          }
        }
      });

      const seriesData: number[] = segments.map((segment) => {
        const negativeCount = negativeCounts[segment];
        const totalCount = segmentCounts[segment];
        const percentage = (negativeCount / totalCount) * 100;
        return Math.round(percentage);
      });

      this.barChart = new Chart({
        chart: {
          type: 'bar',
          backgroundColor: '#dfdfdf',
        },
        title: {
          text: ' ',
          style: {
            color: '#808080',
          },
        },
        xAxis: {
          categories: segments,
        },
        yAxis: {
          title: {
            text: 'Values (%)',
          },
          labels: {
            format: '{value}%',
          },
          tickInterval: 5,
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true,
            },
            borderColor: '#808080',
            borderWidth: 1,
          },
        },
        series: [
          {
            name: 'Segment',
            type: 'bar',
            data: seriesData,
          },
        ],
        accessibility: {
          enabled: false,
        },
      });
    }
  }

  ngAfterViewInit() {
    const seriesData = this.barChart.ref['series'][0]['points'];

    seriesData.forEach((point) => {
      const value = point['y'];
      let color;
      if (value! <= 5) {
        color = {
          linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
          stops: [[0, '#b6d7a8']],
        } as any;
      } else if (value! <= 10 && value! > 5) {
        color = {
          linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
          stops: [
            [0, '#ffe599'],
            [0.5, '#ffe599'],
            [1, '#b6d7a8'],
          ],
        } as any;
      } else if (value! >= 10 && value! > 10) {
        color = {
          linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
          stops: [
            [0, '#ea9999'],
            [0.5, '#ffe599'],
            [1, '#b6d7a8'],
          ],
        } as any;
      }
      point.update(
        {
          color: color,
        },
        true,
        false
      );
    });
  }
  backClick() {
    this.router.navigate(['/home']);
  }
}
